import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";

/** Password input with a show/hide control. The value is held by the parent and
 *  never persisted anywhere. */
export const PasswordField = ({
  id,
  label,
  value,
  onChange,
  testId,
  autoComplete = "new-password",
  disabled = false,
  required = true,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <div className="qw-field">
      <label htmlFor={id}>{label}</label>
      <div className="qw-pw-input-wrap">
        <input
          id={id}
          className="qw-input"
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          disabled={disabled}
          required={required}
          data-testid={testId}
        />
        <button
          type="button"
          className="qw-pw-toggle"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? t("password.hide") : t("password.show")}
          aria-pressed={visible}
          data-testid={`${testId}-toggle`}
        >
          {visible ? <EyeOff size={16} aria-hidden="true" /> : <Eye size={16} aria-hidden="true" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
